export const locale = {
  lang: {
    russian: "Русский",
    uzbekLatin: "O‘zbek (Lotin)",
    uzbekKrill: "Ўзбек (кирилл)",
    kr : "Qaraqalpaq (latın)"
  },
  lotin: " (лотинча)",
  search: "Қидирув",
  obnamuna: "Объективка намунаси",
  photoCan: "Номзоднинг расми",
  selectedVakant: "Танланган бўш иш ўринлари",
  seriaNumber: "Паспорт серияси ва рақам",
  staff_requirement_1: "Лавозимнинг фаолият йўналиши ва вазифалари",
  staff_requirement_2: "Лавозим учун расмий талаблар",
  with_me: "Биз билан қуйидаги натижаларга эришишингиз мумкин",
  staff_requirement_card_1: "Барча меҳнат шароитлари яратилган замонавий идора",
  staff_requirement_card_2: "Замонавий фикрлайдиган ва аҳил меҳнат жамоаси",
  staff_requirement_card_3:
    "Муносиб иш ҳақи (махсус унвон-мартаба даражаси, иш стажи, ойлик шахсий устама ва бошқа қўшимчалар)",
  staff_requirement_card_4:
    "Ишончли хизмат карьераси, юқори лавозимларга кўтарилиш имконияти",
  staff_requirement_card_5:
    "Профессионал ходимлар орасида катта иш тажрибаси ва бебаҳо касбий кўникмаларни орттириш имконияти",
  staff_requirement_card_6:
    "Xорижда малака ошириш ва стажировка ўташ имконияти",
  home: {
    menuText1: "Aдлия органлари ва муассасаларида",
    menuText2: "бўш иш ўринлари",
    search: "Aдлия органлари ва муассасалари",
    countEnnounment: "Актив эълонлар",
    countEnnounmentInactive: "Архивдаги эълонлар",
    searchRegion: "Xудуд бўйича қидирув",
    searchJob: "Лавозим бўйича қидирув",
    statistic: "Статистика",
    vacancyCount: "Эълонлар",
    vacancies: "Бўш иш ўринлари",
    applicants: "Xужжат топширганлар",
    recruited: "Ишга олинганлар",
    lavozim: "Лавозим",
    vacancy: "Бўш иш ўрни",
    company: "Ўзбекистон Республикаси Aдлия вазирлиги",
    havola: "Бизнинг манзиллар",
    nomzod: "Номзодлар",
    close: "Ёпиш",
    sendDocument: "Xужжатларни юбориш",
    aboutLavozim: "Лавозим ҳақида",
    aboutAll: "Умумий маълумот",
    vazirlik: "Вазирлик",
    bolim: "Бошқарма(бўлим)",
    lavozimToifa: "Лавозим тоифаси",
    lavozim: "Лавозим",
    jobOn: "Бўш иш ўрни",
    createDate: "Эълон берилган санаси",
    finishDate: "Эълон тугаш санаси",
    modalTitle:"ID-карта олганингиздан сўнг, OneID тизимидан маълумотларингизни янгиланг",
    skipping: "Ўтказиб юбориш",
    updateInformation: "Маълумотларни янгилаш"
  },
  status: "Ҳолати",
  secury: {
    fullMsg:
      "Парол камида 8 та белгидан, лоақал битта кичик ҳарфдан, битта катта ҳарфдан, битта рақамдан ва битта махсус белгидан иборат бўлиши керак.",
    msg1: "Парол",
    msg2: "лоақал камида 8 та белгидан ",
    msg3: "лоақал битта рақамдан ",
    msg4: "лоақал битта кичик ҳарфдан ",
    msg5: "лоақал битта катта ҳарфдан ",
    msg6: "битта махсус белгидан ",
    msg7: " иборат бўлиши керак.",
    msg8: "Кирилл алифбосидан фойдаланманг",
    successPswdSecury: "Парол қабул қилинди.",
    successNoPswdSecury: "Парол қабул қилинмади.",
  },
  usernameAlready: "Ушбу фойдаланувчи номи аллақачон мавжуд",
  isSaved: "Киритилган маълумотларни сақлайсизми?",
  messages: "Xabarlar",
  org: "Ташкилот",
  annoucement: "Эълонлар",
  additionalDoc: "Қўшимча ҳужжатлар юклаш",
  expireDateMessage: "Тест топшириш учун берилган муддат тугади",
  pasportInfo: "Паспорт маълумотлари",
  finishSure: "Синовни тугатишингизга аминмисиз",
  testAnswers: "Тест жавоблари",
  expiredDate: "Тугаш муддати",
  givenDate: "Берилган сана",
  createdDate: "Эълон қўшилган сана",
  variantlar: "Вариантлар",
  inPercent: "Тест жавоби фоизда",
  result: "Натижа",
  testResult: "Тест натижаси",
  doc: "Ҳужжатлар",
  nameDoc: "Ҳужжат номи",
  allTest: "Жами саволлар сони",
  allTestCorrect: "Тўғри жавоблар сони",
  EmployeeFIO: "Номзод",
  allTestNoCorrect: "Нотўғри жавоблар сони",
  showArizaInfo: "Номзоднинг аризаси",
  forLogin: "Тизимга кириш учун",
  status: {
    PASSED_TEST: "Тест муваффақиятли якунланди",
    FAILED_TEST: "Тестдан ўтолмади",
    TEST: "Тест топшириш",
    MEETING: "Номзод билан учрашув",
    SEND_DOCUMENT: "Ҳужжатлар юборилди",
    SEEN: "Номзоднинг ҳужжатлари кўриб чиқилди",
    REGISTERED: "Номзод рўйхатдан ўтди",
    CONTRACT: "Шартнома",
    NOT_ACCEPTED: "Қабул қилинмади",
    TEST_PROCESS: "Тест бошланди",
    PASSED_MEETING: "Суҳбатдан ўтди",
    FAILED_MEETING: "Суҳбатдан ўтолмади",
    JOB_SUBMIT: "Ишга қабул қилинган",
    DELETED: "Қайтариб олинган",
  },
  warning: {
    noInformation: "Маълумот топилмади",
    noChoosen: "Файл танланмади",
    noInfo: "Агар сизда маълумот ёқ бўлса",
    dataIncomplate: "Илтимос, маълумотларни тўғри киритинг",
    tokenExpired: "Токен муддати тугаган",
    sure: "Ишончингиз комилми",
    finishTest: "Тест вақти тугади",
    notSaved: "Ўзгаришлар сақланиб қолмаслиги мумкин",
    successReg: "Рўйхатдан муваффақиятли ўтдингиз",
    enter: "Малумотларни тўлиқ киритиш керак",
    warInfo: "Шахсий кабинетингиздаги маълумотларни тўлдиринг",
    selectInfo: "Ушбу еълондаги бўш иш ўрнига ҳужжат топширгансиз",
    loginInfo:
      "Ҳужжат юборишдан олдин шахсий кабинетингизга кирган бўлишингиз керак!",
  },
  percent: {
    title: "Фоиз",
    sign: "%",
  },
  allowance: {
    percent: "Фоиз %",
    department: "Бўлим",
  },
  succes: {
    SEND_DOCUMENT: "Ҳужжатлар юборилди",
    saved: "Муваффақиятли сақланди",
    createEmployee: "Ходим муваффақиятли яратилди!",
  },
  transliteratsiya: "Транслитерация",
  answerDoc : "Жавоб хати",
  dashboard: "Меню",
  total: "Умумий",
  other: "Бошқалар",
  recentActivity: "Сўнгги ҳаракатлар",
  empty: "Бўш",
  login: {
    loginWithOneId: "One Id орқали кириш",
    videoInfo: "Танловга ҳужжатларни тақдим қилиш",
    videoLesson: "бўйича видео қўлланма",
    email: "Электрон почта манзил",
    verify: "Тасдиқланг",
    phone: "Телефон",
    byToken: "Калит билан тизимга киринг",
    username: "Фойдаланувчи номи (Логин)",
    password: "Парол",
    title: "Тизимга кириш",
    account: ",Ҳисобингизга киринг",
    come_out: "Кириш",
    come_up: "Чиқиш",
    update: "Калит сўзни ўзгартириш",
    userProfile: "Фойдаланувчининг профили",
    currentPassword: "Ҳозирги калит сўз",
    newPassword: "Янги калит сўз",
    confirmPassword: "Калит сўзни тасдиқланг",
    inn: "СТИР",

    forgetPassword: "Паролни унутдингизми?",
    enteredInfo: "Шахсий маьлумотларни киритиш",
    ByregisteredInfo:
      "Рўйхатдан ўтганингизда фойдаланган электрон почта ёки телефон рақамизни киритинг",
    forgetPasswordTitle:
      "Хавфсизлик сабабли, бу ҳақиқатан ҳам сиз эканлигингизга ишонч ҳосил қилишимиз керак. Давом этиш учун қуйидаги шахсий маълумотларингизни қайта киритинг.",
    forgetTitle: "Қуйидаги шахсий маълумотларингиздан бирини киритинг",
    byusername: "Фойдаланувчи номи",
    bypassport: "Паспорт серияси ва рақами",
    Byregistered:
      "Рўйхатдан ўтганингизда фойдаланган электрон почта ёки телефон рақамни танланг",
    sendConfirmCode: "Юборилган тасдиқлаш коди ва янги паролни киритинг",
    confirmCode: "Тасдиқлаш коди",
    newPasswordEntered: "Янги парол",
    forgetConfirm: "Тасдиқлаш",

    or: "Ёки",
    account: "Aккоунт яратасзми?",
    registration: "Рўйхатдан ўтиш",
    oferta: "Мен оммавий таклиф шартларини қабул қиламан ва шахсий маълумотларимни қайта ишлашга розиман",
    accountYes: "Aккоунтингиз мавжудми?",
    verifiyCodeWhere: "Тасдиқлаш кодини қайерга юбориш керак?",
    entered: " киритинг",
    yourDid: "Сиз бу нарсаларни қилдингиз!",
  },
  register: {
    text: {
      text1:
        "АДЛИЯ ОРГАНЛАРИ ВА МУАССАСАЛАРИДА ХОДИМЛАРНИ ИШГА ҚАБУЛ ҚИЛИШ ТАРТИБИ",
      text2: "Умумий қоидалар",
      text3:
        "Адлия органлари ва муассасаларига жинси, ёши, ирқи, миллати, тили, ижтимоий\n" +
        "                келиб чиқиши, мулкий ҳолати ва мансаб мавқеи, динга бўлган муносабати, эътиқоди,\n" +
        "                жамоат бирлашмаларига мансублигидан қатъи назар, ўзининг касбий, ишчанлик, шахсий\n" +
        "                ва ахлоқий фазилатлари, маълумоти даражаси ва соғлиғига кўра адлия органлари\n" +
        "                ва муассасаларига юклатилган вазифаларни бажаришга қодир бўлган Ўзбекистон\n" +
        "                Республикаси фуқаролари ёки Ўзбекистон Республикаси Президентининг алоҳида\n" +
        "                қарорлари билан ўрнатилган тартибда хорижий давлатларнинг фуқаролари ва фуқаролиги\n" +
        "                бўлмаган шахслар қабул қилинади.",
      text4:
        "Қуйидагилар адлия органлари ва муассасаларига ишга қабул қилиниши мумкин эмас:",
      text5: "- ўн олти ёшга тўлмаган шахслар;",
      text6:
        "- белгиланган тартибда муомалага лаёқатсиз ёки муомала лаёқати чекланган\n" +
        "                деб топилган шахслар;",
      text7:
        "- адлия органи ёки муассасасининг ишлаб турган ходими билан яқин қариндош\n" +
        "                ёки қуда-анда бўлса (ота-оналар, ака-укалар, опа-сингиллар, фарзандлар, эр-хотинлар, шунингдек\n" +
        "                эр-хотинларнинг ота-оналари, ака-укалари, опа-сингиллари ва фарзандлари), агар ишга қабул қилинаётган\n" +
        "                ёки тайинланаётган лавозим улардан бири иккинчисига бевосита бўйсуниб ёки унинг назорати остида хизмат\n" +
        "                қилишни тақозо қилса;",
      text8:
        "- ишга кириш учун сохта ҳужжатлар ёки била туриб ёлғон маълумотлар тақдим этган бўлса;",
      text9:
        "- судланганлик ҳолати тугалланмаган ёки судланганлиги олиб ташланмаган шахслар;",
      text10: "- қонун ҳужжатларида белгиланган бошқа ҳолатлар.",
      text11:
        "Адлия органлари ва муассасаларига ходимларни ишга қабул қилиш бўйича танлов адлия органлари ва\n" +
        "                муассасаларининг кадрлар таркибини ишчанлик, шахсий ва ахлоқий фазилатлари, маълумоти даражаси ва\n" +
        "                соғлиғига кўра юклатилган вазифа ва функцияларни бажаришга лаёқатли бўлган ходимлар билан таъминлаш\n" +
        "                мақсадида ўтказилади.",
      text12:
        "Танлов адлия органлари ва муассасаларининг раҳбарлари томонидан ташкил\n" +
        "                этиладиган камида 5 нафар ходимларидан иборат махсус комиссия томонидан\n" +
        "                меритократия, очиқлик ва мустақиллик тамойиллари асосида ўтказилади.Келишувга асосан ҳуқуқни муҳофаза\n" +
        "                қилувчи органлар, суд ва нодавлат нотижорат ташкилотлари ҳамда жамоатчилик вакиллари комиссия таркибига\n" +
        "                киритилиши мумкин.",
      text13:
        "Махсус комиссия йиғилиши аъзоларининг камида 2/3 (учдан икки) қисми қатнашган тақдирда ваколатли\n" +
        "                ҳисобланади.",
      text14: "Танлов босқичлари",
      text15: "Танлов қуйидаги босқичлардан иборат:",
      text16:
        "1. Бўш иш ўрнига ҳужжат топширган номзодларни дастлабки ўрганиш;",
      text17: "2. Тест синови;",
      text18:
        "3. Номзод билан унинг назарий билимлари ва касбий лаёқатини аниқлаш юзасидан суҳбат ўтказиш.",
      text19:
        "Танлов жараёнлари ўтказилаётган жойда Махсус комиссия аъзолари, Ишчи орган вакиллари ва номзоддан\n" +
        "                ташқари бегона шахсларнинг ҳозир бўлишига рухсат берилмайди.",
      text20: "Танловда иштирок этиш учун талаблар",
      text21:
        "Танловда иштирок этиш истагини билдирган номзод Адлия вазирлигнинг\n" +
        "                vacancy.adliya.uz сайти орқали рўйхатдан ўтиб, номзоднинг шахсий варақаси (сўровнома\n" +
        "                ёки маълумотнома-объективка иловага мувофиқ), дипломнинг нусхаси, чет элда ўқиган\n" +
        "                бўлса, дипломи нострификациядан ўтганлигини тасдиқловчи гувоҳнома, олий ёки ўрта махсус, касб-ҳунар\n" +
        "                таълим муассасаларининг битирувчи курсларида таълим олаётганлар бундан мустасно ва паспортнинг электрон\n" +
        "                шаклини тизимга бириктириши лозим.",
      text22:
        "Номзод бўш иш ўринлари ҳақидаги эълонда кўрсатилган лавозимларнинг фақат биттасини танлаш ва\n" +
        "                танланган лавозим бўйича танловда иштирок этиши мумкин.",
      text23:
        "Бир вақтнинг ўзида бир нечта лавозимга ҳужжат топширишга йўл қўйилмайди.",
      text24: "Тест синови",
      text25:
        "Тест саволлари 30 тадан савол, ҳар бир саволга 4 та (“А”, “B”, “C”, “D”) жавоблардан иборат. Тест синови\n" +
        "                vacancy.adliya.uz сайтидаги шахсий кабинет орқали амалга оширилади.",
      text26: "Тест саволларига жавоб бериш учун 30 дақиқа вақт берилади.",
      text27:
        "Ҳар бир тест саволига фақат битта жавоб белгиланиши лозим. Тўғри жавоб учун\n" +
        "                1 балл, жавоб белгиланмаган ёки нотўғри бўлган тақдирда 0 балл қўйилади",
      text28:
        "Тест синови натижасида камида 21 балл тўплаган номзод кейинги босқичга, яъни номзоднинг назарий\n" +
        "                билимлари ва касбий лаёқатини аниқлаш юзасидан суҳбатга чақирилади ва бу ҳақида номзоднинг шахсий\n" +
        "                кабинетига хабарнома жўнатилади.",
      text29: "Суҳбат жараёни",
      text30:
        "Танлов бошлангунга қадар Ишчи орган томонидан номзоддан соғлиғи ҳолати сўралади. Ўзини ёмон ҳис\n" +
        "                қилаётганидан шикоят қилган номзодлар танловга қўйилмайди. Бундай ҳолатда далолатнома тузилади ва унга\n" +
        "                навбатдаги танловда иштирок этиш ҳуқуқи тушунтирилади.",
      text31:
        "Ишчи орган Махсус комиссия аъзолари ва номзодларга вакант лавозимлар ҳақидаги эълон жойлаштирилган\n" +
        "                жой ва сана, ҳужжатларни топшириш муддатлари, танловда иштирок этиш учун келиб тушган аризалар сони,\n" +
        "                шундан рад қилинганлар\n" +
        "                ва уларнинг сабабларини ҳамда танлов куни ҳозир бўлган номзодларнинг рўйхатини ўқиб эшиттиради.",
      text32:
        "Номзоднинг назарий билимлари ва касбий лаёқатини аниқлаш, унинг лавозим касб фаолиятига боғлиқ\n" +
        "                қонунчилик соҳаси, умумий қонунчилик асослари, амалиётда кўп учрайдиган муаммоли ҳолатлар (казуслар)нинг\n" +
        "                ечими бўйича суҳбат ўтказилади.",
      text33:
        "Номзод суҳбат саволларни генерация ахборот тизими орқали тасодифий танлаш йўли билан олади.\n" +
        "                Саволларни ўзгартиришга йўл қўйилмайди.",
      text34:
        "Номзод тушган саволларга жавоб бера олмаса ёки берилган жавоблар асосида номзоднинг билим\n" +
        "                даражасини аниқлашнинг имконияти бўлмаса, Махсус комиссия раисининг рухсати билан қўшимча саволлар\n" +
        "                берилиши мумкин. Қўшимча саволлар олдинги саволларга берилган жавобларни\n" +
        "                аниқлаштириш мақсадида берилиши ва олдинги саволлар доирасидан четга чиқмаслиги лозим.",
      text35:
        "Номзод томонидан берилган жавоблар аниқ, лўнда ва айнан савол мазмуни билан мос бўлиши ҳамда битта\n" +
        "                саволга жавоб бериш давомийлиги икки дақиқадан ошмаслиги лозим. Қўшимча саволлар берилган ҳолатларда\n" +
        "                суҳбат давомийлиги яна ўн дақиқагача узайтирилиши мумкин.",
      text36:
        "Суҳбатда бериладиган саволлар рўйхати Махсус комиссия раиси томонидан тасдиқланиб, вазирликнинг\n" +
        "                расмий веб-сайтида эълон қилинади ҳамда қонунчиликда, шунингдек жамиятнинг ижтимоий-иқтисодий ва сиёсий\n" +
        "                ҳаётида бўлаётган муҳим ўзгаришлардан келиб чиққан ҳолда ҳар йили янгилаб борилиши мумкин.",
      text37:
        "Суҳбат натижалари бўйича ҳар бир савол ўн баллик тизимда баҳоланади.",
      text38: "Жавобларни баҳолаш қуйидаги мезонлар асосида амалга оширилади:",
      text39: "0 балл – саволга жавоб беролмаслик;",
      text40: "1-3 балл – савол бўйича умумий тушунчага эга эмаслиги;",
      text41: "4-7 балл – саволга умумий ёки қисман жавоб бериш;",
      text42: "8-10 балл – саволга тўлиқ ва атрофлича жавоб бериш.",
      text43:
        "Бунда Махсус комиссия аъзоларининг ҳар бири суҳбат натижаси бўйича, ҳар бир савол юзасидан\n" +
        "                талабгорга белгиланган шаклдаги баҳолаш варақасига балл қўяди. Махсус комиссиянинг ҳар бир аъзоси\n" +
        "                алоҳида баҳолаш варақасини тўлдиради. Баҳолаш варақасини комиссиянинг бошқа аъзоларига кўрсатиш\n" +
        "                тақиқланади ва балларни ўзгартиришга йўл қўйилмайди.",
      text44:
        "Суҳбат якунлари бўйича комиссия аъзолари томонидан номзодга қўйилган баллар умумлаштириш ва ўртача\n" +
        "                балл ҳисоблаб чиқариш учун Ишчи органга берилади. Ишчи орган томонидан номзодга қўйилган баллар\n" +
        "                белгиланган шаклдаги жавоблар варақасига қайд қилинади.",
      text45:
        "Номзод томонидан тўпланиши мумкин бўлган энг юқори баллнинг 56 фоизи\n" +
        "                ва ундан юқорисини тўплаганда номзод лавозимга тавсия этилади. Номзод томонидан тўпланиши мумкин бўлган\n" +
        "                энг юқори баллнинг 55 фоизидан кам балл тўплаганда комиссия аъзолари томонидан номзод суҳбатдан ўтмаган\n" +
        "                деб эътироф этилади.",
      text46:
        "Махсус комиссия суҳбат натижасига мувофиқ номзодни топширган вакант лавозимдан бошқа бир вакант\n" +
        "                лавозимга ишга қабул қилишга тавсия қилиш ҳуқуқига эга.",
      text47:
        "Номзод томонидан тўпланган баллар, баҳолаш натижалари ҳамда комиссия қарори шу куннинг ўзида\n" +
        "                танловда иштирок этган номзодларга ўқиб эшиттирилади.",
      text48:
        "Номзод томонидан тўпланган баллар, баҳолаш натижалари ҳамда комиссия қарори шу куннинг ўзида\n" +
        "                танловда иштирок этган номзодларга ўқиб эшиттирилади.",
      text49: "Номзоднинг шикоят қилиш ҳуқуқи",
      text50:
        "Танлов натижаларидан норози бўлган номзод ўн кун муддат ичида адлия вазирига, шунингдек судга шикоят\n" +
        "                билан мурожаат қилиши мумкин.",
      text51:
        "Танлов тартиби бузилган такдирда ёки коррупция ҳолатлари ҳақида хабарларни Адлия вазирлигининг\n" +
        "                “1008” ишонч телефонига ёки @antikorbot телеграм каналига мурожаат қилишингиз мумкин.",
    },
    getconfirmCode: "Жўнатиш",
    phone: "Телефон",
    title: "Рўйхатдан ўтиш",
    firstName: "Исм",
    lastName: "Фамилия",
    username: "Фойдаланувчи номи (Логин)",
    password: "Парол",
    confirmPassword: "Паролни тасдиқланг",
    email: "Электрон почта",
    confirmCode: "Тасдиқлаш коди",
    passport: "Паспорт серияси ва рақами",
    next: "Кейинги",
    info_1: "Рўйхатдан ўтишда ёки паролни тиклашда муаммо юзага келганда",
    info_2: "телеграм ботга мурожаат қилинг",
  },
  variant: {
    en: "Variant (lotin)",
    ru: "Вариант(русский)",
    uz: "Вариант(кирилл)",
    kr: "Qaraqalpaq",
  },
  savol: {
    en: "Savol (lotin)",
    ru: "Вопрос(русский)",
    uz: "Савол(кирилл)",
    kr: "Qaraqalpaq",
  },

  actions: {
    usernameError: "Бўш жой киритиш мумкин емас!",
    tests: "Тестлар рўйхати",
    print: "Чоп қилиш",
    enteredEmail: "Електон почта манзилингизни киритинг",
    enterPhone: "Телефон номерингизни киритинг",
    changeInfo: "Маълумот киритиш",
    selectKey: "Ушбу калитни танланг",
    read: "O'qish",
    download: "Юклаб олиш",
    uploadDiplom: "Дипломни юклаш",
    uploadObyektivka: "Обективкани юклаш",
    select: "Танлаш",
    selectVacancy: "Бўш иш ўрни танлаш",
    finishTest: "Тестни тугатиш",
    yes: "Ҳа",
    no: "Йўқ",
    selectAnnoucement: "Эълонни танлаш",
    back: "Орқага",
    addQuestion: "Савол ясаш",
    uploadCopy: "Паспорт нусхасини юклаш",
    uploadImage: "Расм юклаш",
    sendDocument: "Ҳужжатларни юбориш",
    send: "Юбориш",
    clear: "Тозалаш",
    createEmployee: "Ходим яратиш",
    sendForConfirmation: "Тасдиқлаш учун юборинг",
    enterSomeThing: "Бирор нарсани киритинг ..",
    title: "Ҳаракатлар",
    add: "Қўшиш",
    save: "Сақлаш",
    cancel: "Бекор қилиш",
    next: "Кейинги",
    prev: "Олдинги",
    choose_file: "Файлни танланг",
    filter: "Саралаш",
    delete: "Ўчириш",
    update: "Янгилаш",
    all: "Ҳаммаси",
    edit: "Таҳрирлаш",
    editData: "Маълумотларни таҳрирлаш",
    displayAll: "Ҳаммасини кўрсатиш",
    choosePhoto: "Суратни танланг",
    selectAll: "Ҳаммасини танланг",
    createUser: "Фойдаланувчини яратинг",
  },
  error: {
    passport_error:
      "Пасспорт сериасини киритиш мажбурий ва узунлиги 2 та бўлиши керак",
    name_error: "Бу майдон бўш бўлиши мумкин емас",
    netToken: "Сизда калит йўқ",
    login_error: "Фойдаланувчи номи ёки парол хато",
    already_success: "Siz ro'yhatdan o'tgansiz...",
    netAccess: "Рухсат йўқ",
    title: "Хатолик!",
  },
  numberAnnounsment: "Эълон рақами",
  orderNumber: "Таъртиб рақами",
  staff: {
    totalStavka: "Умумий иш тажрибаси",
    stavka: "Ставка",
    salary: "Иш ҳақи",
    arxiv: "Штатлар жадвали архиви",
    changeReason: "Штатлар жадвалининг ўзгариши сабаби",
    list: "Штатлар жадвали",
    minSalary: "Енг кам иш ҳақи",
    position: "Лавозим",
    typePosition: "Лавозим тури",
    workWithDepartments: "Бўлимлар билан ишлаш",
    workWithPosition: "Лавозимлар билан ишлаш",
    staffCount: "Штатлар сони",
    status: "Статус",
    vacancy: "Бўш иш ўрни",
    workLoadStaff: "Штатларнинг иш юкламалари",
    refPosition: "Лавозимлар",
    allowances: "Имтиёзлар",
    ranks: "Даража",
    tariff: "Таъриф",
  },
  menu: "Меню",
  employees: {
    pnfl: "ЖШШИР кўриш",
    searchPnfl:"ЖШШИР",
    dataPassport: "Паспорт маълумотларини олиш",
    title: "Ходимлар",
    personalCard: "Шахсий варақаси",
    birthDate: "Туғилган сана",
    appointmentsTransfers: "Тайинланиш ва ўтказиш",
    rotation: "Ходимларни ротация қилиш",
    dismissal: "Ходимни бўшатиш",
    dismissedList: "Бўшатилган ходимлар рўйхати",
    fullName: "ФИО",
    language: "Тил",
    language_status: "Тил холати",
    profileBack: "Профилга қайтиш",
    profile: "Профил",
    ob: "Объективка",
    passport: "Паспорт",
    endBeginPassport: "Паспортнинг тугаш ва бошланиш санаси",
    firstName: "Исм",
    lastName: "Фамилия",
    parentName: "Отасининг исми",
    email: "Электрон почта манзили",
    phone: "Телефон",
    mobilePhone: "Қўшимча телефон",
    address: "Манзил",
    addresss: "Манзил",
    birthAddress: "Туғилган жойи",
    birthRegion: "Туғилган вилояти",
    location: "Яшаш жойи",
    placeBirth: "Туғилган жойи",
    passportId: "Паспорт рақами",
    passportGivenDate: "Паспорт берилган сана",
    passportEndDate: "Паспортнинг амал қилиш муддати",
    passportGivenWho: "Паспорт ким томонидан берилган",
    inpc: "ЖШШИР",
    photo: "Ходимнинг фотосурати",
    copyPassport: "Паспорт нусхаси",
    manage: "Ходимларни бошқариш",
    workingDetails: "Иш тафсилотлари",
    seniority: "Иш стажи",
    foreignLang: "Хорижий тиллар",
    familyMembers: "Оила аъзолари",
    partyMembership: "Партия аъзолиги",
    academic_title: "Илмий унвони",
    academic_degree: "Илмий даражаси",
    state_awards: "Давлат мукофотлари",
    education: "Таълим",
    isHeDeputy: "Депутатлиги",
    phones: "Телефонлар",
    endDate: "Ишдан бўшатиш санаси",
    beginDate: "Ишга жойлашиш санаси",
    system: "Тизим",
    whereWorked: "Қаерда ва ким бўлиб ишлаган",
    givenYear: "Берилган сана",
    dead: "Оламдан ўтган",
    alive: "Тирик",
    reason: "Сабаби",
  },
  staffing: {
    title: "Штатлар жадвали",
    totalVacancy: "Жами бўш иш ўринлари",
    totalStaff: "Жами штатлар сони",
  },
  orders: {
    title: "Буйруқлар",
    list: "Буйруқлар рўйхати",
    number: "Буйруқ рақами",
    date: "Буйруқ санаси",
    type: "Буйруқ тури",
    summary: "Хулоса",
    contractNumber: "Меҳнат шартномаси рақами",
    dateOfEmployment: "Ишга жойлашиш санаси",
  },
  certification: {
    title: "Aттестация",
  },
  vacation: {
    title: "Таътиллар",
    send: "Таътилга чиқариш",
    on: "Айни вақтда таътилдаги ходимлар",
    plan: "Таътиллар режаси",
    labor: "Йиллик меҳнат таътили",
    tempAllowance: "Мехнатга лаёқатсизлик варақаси",
    withoutPay: "Иш ҳаққи сақланмаган ҳолда бериладиган таътил",
    careChild: "Бола парваришлаш таътили",
    nextlabor: "Навбатдаги мехнат таътилга чиққан ходимлар",
    withoutContent: "Иш хаққи сақланмаган ҳолда таътилга чиққан ходимлар",
    sickWorkers: "Мехнатга лаёқатсизлик туфайли таътилга чиққан ходимлар",
    maternity: "Бола парваришлаш таътилга чиққан ходимлар",
  },
  monitoringEmployees: {
    title: "Ходимларни мониторинг қилиш",
  },
  businessTrips: {
    title: "Хизмат сафари",
    enterData: "Хизмат сафарини белгилаш",
    on: "Хизмат сафаридаги ходимлар",
  },
  awardsAndBonus: {
    title: "Мукофотлар ва имтиёзлар",
  },
  recruitment: {
    title: "Ишга қабул қилиш",
    etap: "Босқич",
    pasportData: "Паспорт маълумотлари",
    enterpasportData: "Киритилган паспорт маълумотлари",
    degreeEducation: "Илмий даражаси",
    seniority: "Иш тажрибаси",
    familyMembers: "Оила аъзолари",
    additionalData: "Қўшимча маълумотлар",
  },
  departments: "Бўлимлар",
  references: {
    accept: "Қабул қилиш",
    regions: "Туғилган ҳудуди",
    exactAdress: "Вақтинча турар жойи",
    propis: "Доимий яшаш жойи",
    title: "Маълумотнома",
    all: "Барча маълумотлар",
    nationality: "Миллати",
    rectal: "Ҳарбий унвони",
    holiday: "Байрамлар",
    spec_diplom: "Махсус диплом",
    news: "Янгиликлар",
    country: "Мамлакат",
    department_type: "Бўлим тури",
    order_type: "Буйруқ тури",
    work_mode: "Иш тартиби",
    department: "Бўлим",
    holiday_type: "Байрам турлари",
    gender: "Жинси",
    marital_status: "Оилавий ҳолати",
    passport_seria: "Паспорт серия",
    academic_degree: "Илмий даражаси",
    academic_title: "Илмий унвон",
    award: "Мукофат",
    education: "Маълумоти",
    region: "Ҳудуд",
    language: "Тил",
    passportTYpe: "Паспорт тури",
    language_status: "Тил ҳолати",
    military_rank: "Ҳарбий унвон",
    party_membership: "Партиявийлиги",
    reason_for_dismissal: "Ишдан бўшатиш сабаби",
    educational_institution: "Таълим муассасаси",
    education_type: "Маълумоти бўйича мутахассислиги",
    family_member: "Оила аъзолари",
    directory_phone_type: "Телефон тури",
    vatInfo: "ККС (%)",
    bankRequesit: "Банк тафсилотлари",
    bank: "Банк",
    bankAccountType: "Ҳисоб тури",
    accountNumber: "Банк ҳисоб рақами",
    depManagement: "Бўлимларни бошқариш",
    endDate: "Битирув йили",
  },
  name: {
    en: "Nomi(lotin)",
    ru: "Название(русский)",
    uz: "Номи(кирилл)",
    kr: "Qaraqalpaq",
  },
  address: {
    title: "Манзил",
    lt: "Manzil(lotin)",
    ru: "Адрес(русский)",
    uz: "Манзил(кирилл)",
    physical: "Жисмоний жойлашуви",
    legal: "Юридик манзили",
    phone: "Телефон",
    email: "Электрон почта манзили",
  },
  userManagement: {
    title: "Фойдаланувчиларни бошқариш",
    roles: "Роллар",
    permissions: "Рухсатлар",
    users: "Фойдаланувчилар",
  },
  roles: {
    name: "Номи",
    code: "Коди",
    permissions: "Рухсатлар",
  },
  permissions: {
    title: "Рухсатлар",
    name: "Исм",
    type: "Тури",
    code: "Код",
    sort: "Саралаш",
  },
  date: "Сана",
  createdDate: "Яратилган сана",
  confirm_delete: "Ҳақиқатан ҳам ўчирмоқчимисиз",

  permessionMangement: {
    References: "Маълумотнома",
    Department: "Бўлим",
    // DirectoryBankAccountType: "Банк ҳисоб варақасининг тури",
    // DirectoryPhoneType: "Телефон тури",
    // DirectoryEducation: "Таълим",
    // DirectoryEducationType: "Таълим тури",
    DirectoryOrder: "Буйруқлар рўйхати",
    // DirectoryFamilyMember: "Оила аъзолари",
    // DirectoryBank: "Банк",
    // DirectoryRegion: "Минтақа",
    // DirectoryMilitaryRank: "Ҳарбий унвон",
    // DirectoryKindOfHoliday: "Дам олиш кунлари турлари",
    // DirectoryCountry: "Мамлакат",
    // DirectoryTypePosition: "Лавозимни киритинг",
    // DirectoryEducationalInstitution: "Таълим муассасаси",
    // DirectoryAcademicTitle: "Илмий унвон",
    // DirectoryOrderType: "Буйруқ тури",
    // DirectoryAcademicDegree: "Илмий даражаси",
    // DirectoryHoliday: "Байрамлар",
    // DirectoryGender: "Қават",
    // DirectoryPartyMembership: "Партия аъзолиги",
    // DirectoryNationality: "Миллати",
    // DirectoryDepartmentType: "Бўлим тури",
    // DirectoryMaritalStatus: "Оилавий ҳолат",
    // DirectorySpecDiploma: "Махсус диплом",
    // DirectoryLanguage: "Тил",
    // DirectoryWorkMode: "Иш тартиби",
    // DirectoryDepartment: "Бўлим",
    // DirectoryRectal: "Ректал",
    // DirectoryLanguageStatus: "Тил ҳолати",
    // DirectoryAward: "Соврин",
    // DirectoryReasonForDismissal: "Ишдан бўшатиш сабаби",
    // DirectoryPassportSerial: "Паспорт серияси",
    // DirectoryPassportType: "Паспорт тури",
    // DirectorySystem: "Тизим",

    // EMPLOYEE

    EmployeeAllowance: "Имтиёзлар",
    EmployeeAcademicTitle: "Илмий унвон",
    EmployeeLanguage: "Тил",
    EmployeeAward: "Соврин",
    EmployeeWork: "Ходимларнинг иши",
    Employee: "Ходимлар",
    EmployeeFamilyMember: "Оила аъзолари",
    EmployeeMemberOfDeputy: "Депутатлиги",
    EmployeeAcademicDegree: "Илмий даражаси",
    EmployeeEducation: "Таълим",
    EmployeeRectal: "Ҳарбий унвони",
    EmployeeHoliday: "Байрамлар",
    MemberOfDeputy: "Партия аъзолиги",
    EmployeePhoto: "Ходимларнинг фотосурати",
    EmployeePhoneNumber: "Телефон",
    EmployeeExperience: "Иш тажрибаси",
    EmployeePartial: "Қисман",
    EmployeeWageHistory: "Иш ҳақи тарихи",
    EmployeePassportScan: "Паспорт нусхаси",

    //STAFF
    StaffListCheckAllowance: "Имтиёзларни текширинг",
    StaffList: "Ходимлар жадвали",
    StaffPosition: "Лавозим",
    StaffListChangeReason: "Кадрлар жадвалидаги ўзгаришларнинг сабаби",
    StaffListArchive: "Кадрлар архиви",
    StaffMinSalary: "Минимал иш ҳақи",
    StaffListAllowance: "Имтиёзлар",

    //OTHER
    DepartmentAddress: "Бўлим манзили",
    TimeSheetControl: "Вақт варақаси",
    BankRequisite: "Банк тафсилотлари",
    News: "Янгиликлар",
    Role: "Роллар",
    VATInfo: "ҚҚс (%)",
    User: "Фойдаланувчилар",
  },
  forgetPasswordText:
    "Рўйхатдан ўтган тел номерингизга кодни жўнатшимиз учун пасспорт маълумотингизни киритинг:",
  required_error: "Барча керакли майдонларни тўлдиринг",
  send_code: "Телефон ракамингизга код жонатилди !",
  success: "Муваффакийатли сакланди !",
  password_error: "Пароль 8 хонадан кам болиши керак емас!",
  resultFound: "та эълон топилди",
  returnDocument: "Ҳужжатни қайтариб олиш",
  returned: "Ҳужжат қайтариб олинди",
  statusAriza: "АРИЗАНГИЗНИНГ ЖОРИЙ ХОЛАТИ",
  archiveInfo: "Ўзгаришлар тарихи",
  updatedDate: "Ўзгартирилиган сана",
  archive: "архив",
  returnDoc:
    "Эслатма: ҳужжат қайтариб олингандан сўнг, ушбу эълон доирасида ҳужжатлар яна қайта юборилмайди",
  onlyLotin: "фақат лотин алифбоси ҳарфларидан иборат бўлиши керак",
  agreeTest : "Тартиб билан танишиб чиқдим, тестларни ечишга тайёрман",
  alertText: `Адлия вазирлигининг ахборот ресурслари учун интернет тармоғига уланиш хизматларини кўрсатувчи “ONE-NET” оператори томонидан 2023 йилнинг <b> 9-10-11 июнь кунлари соат 00-00 дан 06-00 га қадар</b> техник ишлари олиб борилиши муносабати билан Адлия вазирлиги ахборот тизимлари ишида қисқа муддатли узилишлар кузатилиши мумкин.
  <br/><br/><strong> Шу сабабли номзодларга ушбу вақт оралиғида бўш иш ўринлари бўйича танловларнинг  тест синовини топшириш тавсия қилинмайди.</strong>
  `,
  notice : "Эcлатма",
  IAgree  : "Танишдим"
};
